import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import DiscountService from "../../../Services/QRCodeServices/DiscountService/DiscountService";
import { MenuCategoryDropdown } from "./MenuCategoryDropdown";
import { MenuItemDropdown } from "./MenuItemDropdown";
import { useFormik } from "formik";
import DiscountSchema from "./DiscountSchema";

export const AddDiscount = ({ isOpen, toggle, refreshDiscounts }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      startDate: "",
      endDate: "",
      discountPercentage: "",
      // isActive: true,
      isOverEntireMenu: false,
      categoryIds: [],
      itemIdIds: [],
    },
    validationSchema: DiscountSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          ...values,
          startDate: new Date(values.startDate).toISOString(),
          endDate: new Date(values.endDate).toISOString(),
          // categoryIdIds: values.categoryIds, 
          // itemIdIds: values.itemIds, 
        };

        console.log("Payload:", payload); // Log the payload

        const response = await DiscountService.create({ data: payload });
        console.log("Response:", response); // Log the response

        toggle();
        refreshDiscounts();
        formik.resetForm();
      } catch (error) {
        console.error("Error creating discount:", error);
      }
    },
  });

  const handleCategoryChange = (selectedOptions) => {
    setSelectedCategories(selectedOptions);
    const categoryIds = selectedOptions.map((option) => option.value);
    formik.setFieldValue("categoryIds", categoryIds);
  };

  const handleItemChange = (selectedOptions) => {
    setSelectedItems(selectedOptions || []);
    const itemIdIds = selectedOptions.map((option) => option.value);
    formik.setFieldValue("itemIdIds", itemIdIds);
  };

  const handleCancel = () => {
    formik.resetForm(); // Reset form values
    setSelectedCategories([]); // Reset category dropdown
    setSelectedItems([]); // Reset item dropdown
    toggle(); // Close the modal
  };

  useEffect(() => {
    if (isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  // console.log("date" , new Date());

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Discount</ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <FormGroup>
              <Label for="title">Title</Label>
              <Input
                type="text"
                name="title"
                id="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.title && !!formik.errors.title}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="text-danger">{formik.errors.title}</div>
              ) : null}
            </FormGroup>
          </Row>
          <Row>
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="text"
                name="description"
                id="description"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.description && !!formik.errors.description
                }
              />
              {formik.touched.description && formik.errors.description ? (
                <div className="text-danger">{formik.errors.description}</div>
              ) : null}
            </FormGroup>
          </Row>
          <Row>
            <Col>
          <FormGroup>
            <Label for="startDate">Start Date</Label>
            <Input
              type="date"
              name="startDate"
              id="startDate"
              value={formik.values.startDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.startDate && !!formik.errors.startDate}
              min={new Date().toISOString().split("T")[0]}
            />
            {formik.touched.startDate && formik.errors.startDate ? (
              <div className="text-danger">{formik.errors.startDate}</div>
            ) : null}
          </FormGroup>
          </Col>
          <Col>
          <FormGroup>
            <Label for="endDate">End Date</Label>
            <Input
              type="date"
              name="endDate"
              id="endDate"
              value={formik.values.endDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.endDate && !!formik.errors.endDate}
              min={
                formik.values.startDate ||
                new Date().toISOString().split("T")[0]
              }
            />
            {formik.touched.endDate && formik.errors.endDate ? (
              <div className="text-danger">{formik.errors.endDate}</div>
            ) : null}
          </FormGroup>
          </Col>
          </Row>
          <Row>
          <FormGroup>
            <Label for="discountPercentage">Discount Percentage</Label>
            <Input
              type="number"
              name="discountPercentage"
              id="discountPercentage"
              value={formik.values.discountPercentage}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.discountPercentage &&
                !!formik.errors.discountPercentage
              }
            />
            {formik.touched.discountPercentage &&
            formik.errors.discountPercentage ? (
              <div className="text-danger">
                {formik.errors.discountPercentage}
              </div>
            ) : null}
          </FormGroup>
          </Row>
          <Row>
          <FormGroup>
            <Label for="selectCategory">Category</Label>
            <MenuCategoryDropdown
              value={selectedCategories}
              onChange={handleCategoryChange}
            />
          </FormGroup>
          </Row>
          <Row>
          <FormGroup>
            <Label for="selectItem">Item</Label>
            <MenuItemDropdown
              value={selectedItems}
              onChange={handleItemChange}
            />
          </FormGroup>
          </Row>
          {/* <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                name="isActive"
                checked={formik.values.isActive}
                onChange={formik.handleChange}
              />{" "}
              Active
            </Label>
          </FormGroup> */}
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                name="isOverEntireMenu"
                checked={formik.values.isOverEntireMenu}
                onChange={formik.handleChange}
              />{" "}
              Apply Discount to Entire Menu
            </Label>
          </FormGroup>
          <ModalFooter>
            <Button type="submit" color="success">
              Save
            </Button>{" "}
            <Button color="danger" onClick={handleCancel}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </ModalBody>
    </Modal>
  );
};
